<template>
  <div class="setup-complete-step">
    <div class="success-icon">
      <v-icon size="64" color="success">mdi-check-circle</v-icon>
    </div>
    
    <h2 class="success-title">Setup Complete!</h2>
    <p class="success-message">
      Your vendor profile has been successfully set up. You can now start managing your pest control business.
    </p>
    
    <div class="next-steps">
      <h3 class="next-steps-title">What's Next?</h3>
      <ul class="next-steps-list">
        <li>Manage your services and pricing</li>
        <li>Create and send quotations</li>
        <li>Track customer inquiries</li>
        <li>View your dashboard analytics</li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";

type SetupCompleteStepExpose = {
  getValues?: () => Record<string, any>;
};

// This step doesn't need any values since it's just a completion screen
const values = ref<Record<string, any>>({});

function getValues() {
  return values.value;
}

defineExpose<SetupCompleteStepExpose>({
  getValues,
});
</script>

<style scoped>
.setup-complete-step {
  text-align: center;
  margin: 0 auto;
}

.success-icon {
  margin-bottom: 24px;
}

.success-title {
  font-size: 28px;
  font-weight: 600;
  color: #0f172a;
  margin: 0 0 16px 0;
}

.success-message {
  font-size: 16px;
  color: #64748b;
  line-height: 1.6;
  margin: 0 0 32px 0;
}

.next-steps {
  text-align: left;
  background: #f8fafc;
  border-radius: 12px;
  padding: 24px;
  margin-top: 32px;
}

.next-steps-title {
  font-size: 18px;
  font-weight: 600;
  color: #0f172a;
  margin: 0 0 16px 0;
}

.next-steps-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.next-steps-list li {
  position: relative;
  padding-left: 24px;
  margin-bottom: 12px;
  font-size: 14px;
  color: #475569;
  line-height: 1.5;
}

.next-steps-list li::before {
  content: "✓";
  position: absolute;
  left: 0;
  color: #22c55e;
  font-weight: bold;
}
</style>
